import { Component, Inject, OnInit } from '@angular/core';
import { SalesChannelIface } from '../../../interfaces/sales-channel.iface';
import { SalesChannelService } from '../../../services/sales-channel.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from 'ng2-toastr';

@Component({
  selector: 'app-sales-channel-edition-dialog',
  templateUrl: './sales-channel-edition-dialog.component.html',
  styleUrls: ['./sales-channel-edition-dialog.component.scss']
})
export class SalesChannelEditionDialogComponent implements OnInit {
  salesChannel: SalesChannelIface;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: SalesChannelIface,
    private refDialog: MatDialogRef<SalesChannelEditionDialogComponent>,
    private salesChannelService: SalesChannelService,
    private translateService: TranslateService,
    private toastr: ToastsManager
  ) {
    this.salesChannel = Object.assign({}, data);
  }

  ngOnInit() {}

  async saveChannel(): Promise<void> {
    if (this.salesChannel._id) {
      this.salesChannelService.updateChannel(this.salesChannel).subscribe(
        channel => {
          this.toastr.info(this.translateService.instant('SALES_CHANNEL.TOASTR.INFO.EDIT'));
          this.refDialog.close(channel);
        },
        () => {
          this.toastr.error(this.translateService.instant('SALES_CHANNEL.TOASTR.ERROR.EDIT'), 'Ooops!');
        }
      );
    } else {
      this.salesChannelService.saveChannel(this.salesChannel).subscribe(
        channel => {
          this.toastr.success(this.translateService.instant('SALES_CHANNEL.TOASTR.SUCCESS.ADD'));
          this.refDialog.close(channel);
        },
        () => {
          this.toastr.error(this.translateService.instant('SALES_CHANNEL.TOASTR.ERROR.ADD'), 'Ooops!');
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sales-channels/sales-channel-edition-dialog/sales-channel-edition-dialog.component.ts